


























































import {Component, Vue} from 'vue-property-decorator'
import {appModule, DeviceType} from '@/store/module/AppModule'
import userSession from '@/store/module/UserSession'
import Breadcrumb from '@/component/Breadcrumb/index.vue'
import Hamburger from '@/component/Hamburger/index.vue'
import ErrorLog from '@/component/ErrorLog/index.vue'
import LangSelect from '@/component/LangSelect/index.vue'
import UserApi from "@/api/UserApi";
import {Inject} from "typescript-ioc";
import CompanyLocationApi from "@/api/CompanyLocationApi";
import Location from "@/layout/component/Location/index.vue";

@Component({
    components: {
        Breadcrumb,
        Hamburger,
        ErrorLog,
        LangSelect,
        Location,
    }
})
export default class Navbar extends Vue {

    @Inject
    private userApi!: UserApi

    private get meta(){
        const {meta} = this.$route
        return meta
    }

    isMobile(): boolean {
        return this.device == DeviceType.MOBILE
    }

    get sidebar() {
        return appModule.sidebar
    }

    get device() {
        return appModule.config.device
    }

    get avatar() {
        return userSession.user.avatar
    }

    private toggleSideBar() {
        appModule.toggleSidebar(false)
    }

    private async logout() {
        await this.userApi.logout()
        await userSession.cleanAfterLogout()
        this.$redirector.login()
    }
}
